
import { View } from 'backbone';
import listService          from 'ListService.js';
import undoService          from 'UndoService.js';
import widgetUtil           from 'util/WidgetUtil.js';
import Template from 'behaviors/properties/main/next-stage.ejs';
import textConstants from "../../../../constants/TextConstants";
//=====================================================================
//
// An instance of this view represents a next stage.
//
// Casey Justus, June 7, 2016
//
//=====================================================================

class MainNextStageView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change #nextStage' : 'updateSelectAttributes'
        };

        return this;
    }


    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const oldPropVal = this.model.get(propName);

        this.model.set( propName, propVal ,{silent:true});
        this.model.set('widgetText', widgetUtil.getWidgetText(this.model) ,{silent:true}) ;
        this.model.trigger('widgetTextUpdated');
        this.render();

        undoService.add({
            undo:() => {
                this.model.set( propName, oldPropVal ,{silent:true});
                this.model.set('widgetText', widgetUtil.getWidgetText(this.model) ,{silent:true}) ;
                this.model.trigger('widgetTextUpdated');
                this.render();
            },
            redo:() => {
                this.model.set( propName, propVal ,{silent:true});
                this.model.set('widgetText', widgetUtil.getWidgetText(this.model) ,{silent:true}) ;
                this.model.trigger('widgetTextUpdated');
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE)
    }


    getViewValues(){
        return _.merge(this.model.toJSON(), {
            stages:listService.getWorkflowStages(false, false)
        });
    }


    render() {

        let values = this.getViewValues();
        if(this.template) {
            this.$el.html(this.template(values));
        }

        if(this.model.get('stageId')) {
            $('#nextStage').find('option[value="' + this.model.get('stageId') +'"]').attr('selected', true);
        }
        
        this.delegateEvents();
        return this;
    }

}

export default MainNextStageView;
